// extracted by mini-css-extract-plugin
module.exports = {"page":"not-found_page__tcqop","image":"not-found_image__2cHM7"};